var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table__Property 1=Table",
    className: "table__Property table__1=Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table__Vector",
    className: "table__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M12.202 6.162h9.714v13.622a.974.974 0 0 1-.975.973H3.387a.974.974 0 0 1-.975-.973V6.162h9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M21.673 15.92h-9.227v4.594h8.495a.73.73 0 0 0 .732-.73V15.92Zm-9.227-.486h9.227V11.26h-9.227v4.174Zm-9.79 0h9.302V11.26H2.656v4.174Zm9.79-4.66h9.227v-4.37h-9.227v4.368Zm-9.79 0h9.302v-4.37H2.656v4.368Zm0 9.01c0 .403.327.73.731.73h8.571V15.92H2.656v3.864Zm19.504 0c0 .672-.546 1.216-1.219 1.216H3.387a1.218 1.218 0 0 1-1.219-1.216V5.919H22.16v13.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M2.42 6.162V4.216c0-.537.436-.973.975-.973h17.554c.538 0 .975.436.975.973v1.946H2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M21.68 4.216a.73.73 0 0 0-.731-.73H3.395a.73.73 0 0 0-.732.73V5.92H21.68V4.216Zm.488 2.19H2.176v-2.19C2.176 3.545 2.72 3 3.395 3h17.554c.673 0 1.219.545 1.219 1.216v2.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableChart);
export default __webpack_public_path__ + "static/media/table_chart.b710e094f139209144601ed5c84fb659.svg";
export { ForwardRef as ReactComponent };